import { NationalityEntity } from '../entities/nationality-entity';

export default class State {
  loaded = false;

  items: Array<NationalityEntity> = [];
}
